"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFirstInstalmentDueDate = void 0;
var moment = require("moment-timezone");
function getFirstInstalmentDueDate(interaction) {
    var earliestInstalmentDueDate = moment(interaction.headerInfo.startDate).add(14, "days");
    var latestInstalmentDueDate = moment(interaction.headerInfo.startDate).add(44, "days");
    var initialFirstDueDate = moment(interaction.paymentDetails.instalmentPlan.instalments[0].dueDate);
    var firstDueDate;
    // In cases when earliest Instalment DueDate and latest Instalment DueDate are on same day - we exclude latest,
    // i.e. 12.06 is earliestInstalmentDueDate and 12.07 is latestInstalmentDueDate - we will exclude 12.07 from range
    var datesInBetweenInclusivity = earliestInstalmentDueDate.get('date') === latestInstalmentDueDate.get('date') ? "[)" : "[]";
    // Earliest payment day can be policy.StartDate + 14 days and latest policy.startDate + 44 days.
    // In cases when payment day is before policy.startDate it should be shifted to next month
    // monthShift is responsible for shifting to specific month.
    if (initialFirstDueDate.isBefore(earliestInstalmentDueDate, "day")) {
        // Set instalment dueDate for monthly renewal
        if (interaction.factors.premiumType == "monthly" && interaction.process == "renewal") {
            return initialFirstDueDate;
        }
        firstDueDate = initialFirstDueDate.add(1, "months");
    }
    else if (initialFirstDueDate.isBetween(earliestInstalmentDueDate, latestInstalmentDueDate, "day", datesInBetweenInclusivity)) {
        firstDueDate = initialFirstDueDate;
    }
    else {
        firstDueDate = initialFirstDueDate.subtract(1, "months");
    }
    return firstDueDate;
}
exports.getFirstInstalmentDueDate = getFirstInstalmentDueDate;
//# sourceMappingURL=DirectDebitFunctions.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/home/directDebit/DirectDebitFunctions.js
// module id = 776
// module chunks = 0